<template>
  <div>
    <!-- 导航 -->
    <!-- <ao-nav  navName='market'></ao-nav> -->
      <div class="m-auto w-full">
          <div class="">
              <div class="">
                <!-- <div class="search-box">
                  <div class="search-lt">
                    <img class="icon" src="@/assets/new/sousuo.png" @click="search" alt="">
                    <input class="search" type="text" v-model="key" @input="search" :placeholder="$t('langNew.qsrmz')">
                    <img v-show="key" class="clear-img" src="@/assets/new/guanbishixin.png" @click="clear" alt="">
                  </div>
                </div> -->
                <!-- <div class="tab-wrap">
                  <ul class="tab-box">
                    <li class="tab" :class="{active: tabIdx == 0}" @click="select('')">{{$t('kxt.zx')}}</li>
                    <li class="tab" :class="{active: tabIdx == 1}" @click="select(1)">{{$t('langNew.wh')}}</li>
                    <li class="tab" :class="{active: tabIdx == 2}" @click="select(2)">{{$t('langNew.szhb')}}</li>
                    <li class="tab" :class="{active: tabIdx == 4}" @click="select(4)">{{$t('langNew.gp')}}</li>
                    <li class="tab" :class="{active: tabIdx == 5}" @click="select(5)">{{$t('langNew.zs')}}</li>
                    <li class="tab" :class="{active: tabIdx == 3}" @click="select(3)">{{$t('langNew.js')}}</li>
                    <li class="tab" :class="{active: tabIdx == 6}" @click="select(6)">{{$t('langNew.dzsp')}}</li>
                  </ul>
                </div> -->

               <!-- <div class="tab m-tb-50 bg-f5f5f5 br-20">
                  <div class="tab-item" :class="{active: tabIdx == 0}" @click="select('')">
                    {{ $t('market.tab')[0] }}
                  </div>
                  <div class="tab-item" :class="{active: tabIdx == 1}" @click="select(1)">{{$t('hq.wh')}}</div>
                  <div class="tab-item" :class="{active: tabIdx == 2}" @click="select(2)">{{$t('langNew.jmhb')}}</div>
                  <div class="tab-item" :class="{active: tabIdx == 3}" @click="select(3)">{{$t('商品')}}</div>
                </div> -->
                <ul class="tab_menu ov m-b-30">
                    <li :class="{cur:tabIdx == 1}" @click="select(1)">{{ $t('hq.wh') }}</li>
                    <li :class="{cur:tabIdx == 2}" @click="select(2)">{{ $t('langNew.jmhb') }}</li>
                    <li :class="{cur:tabIdx == 3}" @click="select(3)">{{ $t('商品') }}</li>
                </ul>

                <div>
                  <div class="flex-b flex-wrap w-full" style="display:grid;grid-template-columns: repeat(auto-fill,30%);flex-wrap:wrap;justify-content: space-between;">
                    <div class="box-shadow-14 br-20 w-full m-b-40 p-20" v-for="(item,index) in list.slice(0,6)" :key="index" @click.stop="jump(item.cname,item.currency_type,item.main_type)">
                      <div class="p-b-10"><img class="w-70 h-70" v-show="item.icon"  :src="item.icon" alt=""></div>
                      <div class="font-28 font-b p-b-6">{{item.cname}}</div>
                      <div class="font-24 c-999 sell p-b-20">{{parseFloat(item.now_price) | toFixed4(item.now_price,item.cname)|formatNumberWithCommas}}</div>
                      <div>
                        <img class="w-26 h-29" v-if="item.change_rate < 0" src="@/assets/new/jiantou_xia.png" alt="">
                        <img class="w-26 h-29" v-else src="@/assets/new/jiantou_s.png" alt="">
                        <span class="font-36 c-00895b" :class="{red2: item.change_rate < 0}">{{item.change_rate}}%</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- <div class="">
                <ul class="table-head">
                  <li class="th">{{ $t('hq.mc') }}</li>
                  <li class="th text-center">{{ $t('index.thead')[4] }}</li>
                  <li class="th text-center">{{$t('jy.mc')}}</li>
                  <li class="th text-center">{{$t('jy.mr')}}</li>
                  <li class="th text-right">{{$t('hq.tb')}}</li>
                  <li class="th text-right">{{$t('jgcc.cz')}}</li>
                </ul>
                <ul class="table-body" id="listenScroll">
                    <li class="tr cursor" v-for="(item,index) in list.slice(0,7)" :key="index">
                      <div class="item coin">
                          <div class="t1 flex-center">
                            <span class="">
                              <template v-if="!theme">
                                <img class="collect" v-if="!item.isCollect" src="@/assets/new/shouchang.png" @click.stop="collect(item.cname,item.isCollect)" alt="">
                                <img class="collect" v-else src="@/assets/new/shouchang-light.png" @click.stop="collect(item.cname,item.isCollect)" alt="">
                              </template>
                              <template v-else>
                                <img class="collect" v-if="!item.isCollect" src="@/assets/new/theme/shoucang-white.png" @click.stop="collect(item.cname,item.isCollect)" alt="">
                                 <img class="collect" v-else src="@/assets/new/shouchang-light.png" @click.stop="collect(item.cname,item.isCollect)" alt="">
                              </template>
                              <img class="collect" v-show="item.icon"  :src="item.icon" alt="">
                            </span>
                            <img class="img-icon" v-show="item.icon" :src="item.icon">
                            {{item.cname}}
                          </div>

                      </div>
                      <div class="item change text-center" :class="{red2: item.change_rate < 0}">{{item.change_rate}}%</div>
                      <div class="item sell text-center">{{parseFloat(item.now_price) | toFixed4(item.now_price,item.cname)}}</div>
                      <div class="item buy text-center">{{(parseFloat(item.now_price) + parseFloat(item.buy_add_money)).toFixed(toFixed4(item.now_price,item.cname))}}</div>
                      <div class="item change text-right" v-if="item.prices">
                        <trend v-show="item.prices.length > 0"
                        :class="item.change_rate < 0?'fill-red m-t-20':'fill-green m-t-20'"
                        :data="item.prices.map(Number)"
                        :gradient="item.change_rate < 0?['red']:['green']"
                        :width="60"
                        :height="25"
                        auto-draw
                        smooth
                      >
                      </trend>
                      </div>
                      <div class="item change text-center" v-else>

                      </div>
                      <div class="item text-right cursor" @click.stop="jump(item.cname)">
                        <img class="w-50" src="@/assets/new7/yjt.jpg" alt="">
                      </div>
                    </li>
                    <div class="null-box" v-show="isNoData">
                        <img class="icon" v-if="!theme" src="@/assets/new/Null.png" alt="">
                        <img class="icon" v-else src="@/assets/new/theme/wushuju.png" alt="">
                        <p class="text">{{ $t('market.nodata') }}</p>
                    </div>
                </ul>
              </div> -->

          </div>
          <!-- <nav-bar :navName="'quotes'"></nav-bar> -->
          <loading v-show="isLoad"></loading>
      </div>
    <!-- 脚部 -->
    <!-- <ao-footer></ao-footer> -->
  </div>

</template>

<script>
  // import AoNav from "@/components/AoNav";
  // import AoFooter from "@/components/AoFooter";
// import navBar from '@/components/NavBar.vue'
import loading from '@/components/loading.vue'
export default {
    name: 'market',
    components: {
      // AoNav,
      // AoFooter,
      loading
    },
    data () {
        return {
          theme: false,
          tabIdx: 1,
          key: '',
          currency_type: '',
          main_type: 1,
          isCollect: false,
          list: [],
          collectArr: [],
          isGoTOP: false,
          isNoData: false,
          curDataLength: 10,
          timer: null,
          countdown: 40,
          downTimer: null,
          websock: null,
          currencyAll: '',
          isFirst: 1,
          isMn: false,
          isLoad: false,
          timestamp: 0,
          lockReconnect: false //soket重连
        }
    },
    created(){
      this.tabIdx = this.$route.query.tabIdx || 1;
      this.isMn = JSON.parse(localStorage.getItem('isMn'));
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.timestamp = localStorage.getItem('timestamp') || 0;
      this.collectArr = JSON.parse(localStorage.getItem('collectArr')) || [];
      this.currencyAll = JSON.parse(localStorage.getItem('currencyAll')) || '';

      this.main_type = this.tabIdx;
      this.list = [];
      this.getCurrency();
      // this.initWebSocket();
    },
    mounted() {
      // this.getCurrency();
      // this.settime();
    },
    watch: {
      wsData(val) {
        // console.log('watch获取的数据:',val)
        this.globalWs(val);
      },
    },
    computed: {
      wsData() {
        return this.$store.state.wsData;
      },
    },
    methods: {
      globalWs(e) {
        //数据接收
        if (e) {
          let msg = e ? e : JSON.parse(localStorage.getItem("currencyAll"));
          // localStorage.setItem("currencyAll", JSON.stringify(msg));
            if(typeof msg === 'object'){
              this.currencyAll = msg;
              this.closeTimer();
              let listData = this.list.map(item =>{
                var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                if(this.isWeekend()){
                  if(Date.parse(new Date()) - this.timestamp*1000 - this.currencyAll[item.small_name].time*1000 > 20000){
                    var obj3 = {isBs: true}
                  }else{
                    var obj3 = {isBs: false}
                  }
                }else{
                  var obj3 = {isBs: false}
                }
                item = { ...item,...obj,...obj3 };
                return item
              });
              this.list = listData;//listData.filter(item => item.change_rate != 0)
              if(this.tabIdx == 0){
                this.list = this.list.filter(item => item.isCollect == true);
                if(this.list.length == 0){
                  var zxData = JSON.parse(localStorage.getItem('whList'));
                  this.list = zxData.map(item =>{
                    var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                    if(this.isWeekend()){
                      if(Date.parse(new Date()) - this.timestamp*1000 - this.currencyAll[item.small_name].time*1000 > 20000){
                        var obj3 = {isBs: true}
                      }else{
                        var obj3 = {isBs: false}
                      }
                    }else{
                      var obj3 = {isBs: false}
                    }
                    item = { ...item,...obj,...obj3 };
                    return item
                  });
                }
              }
              if(this.isFirst == 1){
                localStorage.setItem('currencyAll',JSON.stringify(msg));
                // this.getCurrency();
                this.isFirst = 0;
              }
            }
        }
      },
      isWeekend(date = new Date((Math.round(new Date().getTime()/1000) - this.timestamp) * 1000)){
        return date.getDay() % 6 === 0;
      },
       goBack(){
           this.$router.go(-1)
       },
      //  settime(){
      //   this.downTimer = setInterval(() => {
      //     var msg = {
      //       main_type: this.main_type,
      //       utime: new Date()
      //     };
      //     this.websocketsend(JSON.stringify(msg));
      //   }, 30000);
      // },
      // initWebSocket(){ //初始化weosocket
      //     const wsuri = this.webSocketAll;
      //     this.websock = new WebSocket(wsuri);
      //     this.websock.onmessage = this.websocketonmessage;
      //     this.websock.onopen = this.websocketonopen;
      //     this.websock.onerror = this.websocketonerror;
      //     this.websock.onclose = this.websocketclose;
      // },
      // websocketonopen(){ //连接建立之后执行send方法发送数据
      //   if(this.websock.readyState === 1){
      //     var msg = {
      //       main_type: this.main_type,
      //       utime: new Date()
      //     };
      //     this.websocketsend(JSON.stringify(msg));
      //   }
      // },
      // websocketonerror(){//连接建立失败重连
      //   this.reconnect();
      // },
      // websocketonmessage(e){ //数据接收
      //   let msg = e.data;
      //   if (typeof msg === 'string' && msg != 'success') msg = JSON.parse(msg);
      //     if(msg){
      //       if(typeof msg === 'object'){
      //         this.currencyAll = msg;
      //         this.closeTimer();
      //         let listData = this.list.map(item =>{
      //           var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
      //           if(this.isWeekend()){
      //             if(Date.parse(new Date()) - this.timestamp*1000 - this.currencyAll[item.small_name].time*1000 > 20000){
      //               var obj3 = {isBs: true}
      //             }else{
      //               var obj3 = {isBs: false}
      //             }
      //           }else{
      //             var obj3 = {isBs: false}
      //           }
      //           item = { ...item,...obj,...obj3 };
      //           return item
      //         });
      //         this.list = listData;//listData.filter(item => item.change_rate != 0)
      //         if(this.tabIdx == 0){
      //           this.list = this.list.filter(item => item.isCollect == true);
      //           if(this.list.length == 0){
      //             var zxData = JSON.parse(localStorage.getItem('whList'));
      //             this.list = zxData.map(item =>{
      //               var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
      //               if(this.isWeekend()){
      //                 if(Date.parse(new Date()) - this.timestamp*1000 - this.currencyAll[item.small_name].time*1000 > 20000){
      //                   var obj3 = {isBs: true}
      //                 }else{
      //                   var obj3 = {isBs: false}
      //                 }
      //               }else{
      //                 var obj3 = {isBs: false}
      //               }
      //               item = { ...item,...obj,...obj3 };
      //               return item
      //             });
      //           }
      //         }
      //         if(this.isFirst == 1){
      //           localStorage.setItem('currencyAll',JSON.stringify(msg));
      //           // this.getCurrency();
      //           this.isFirst = 0;
      //         }
      //       }
      //     }else{
      //       // this.getAllCurrency()
      //       // setTimeout(()=>{
      //       //   this.getCurrency();
      //       // },1000)
      //       // this.startTimer();
      //     }
      // },
      // websocketsend(Data){//数据发送
      //   if(this.websock.readyState === 1){
      //     this.websock.send(Data);
      //   }
      // },
      // websocketclose(e){  //关闭
      //   this.reconnect();
      //   // this.getAllCurrency();
      //   // setTimeout(()=>{
      //   //   this.getCurrency();
      //   // },1000)
      //   // this.startTimer();
      //   // console.log('断开连接',e);
      // },
      // reconnect() {
      //   var tt;
      //   if (this.lockReconnect) {
      //     return;
      //   }
      //   this.lockReconnect = true;
      //   //没连接上会一直重连，设置延迟避免请求过多
      //   tt && clearTimeout(tt);
      //   tt = setTimeout(() => {
      //     // console.log('执行断线重连...')
      //     this.initWebSocket();
      //     this.lockReconnect = false;
      //   }, 1000);
      // },
      startTimer(){
        if(!this.timer){
          this.timer = window.setInterval(() => {
            this.getAllCurrency()
          },1500);
        }
      },
      closeTimer(){
        if(this.timer || this.timer == null){
          window.clearInterval(this.timer);
          this.timer = 1;
        }
      },
      getAllCurrency(){
        this.$ajax.post(this.HOST2 + '/index/getAllCurrency').then((res) => {
          if(res.data.code == 200){
            let resData = res.data.data;
            this.currencyAll = resData;
            this.list = this.list.map(item =>{
              var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
              if(this.isWeekend()){
                if(Date.parse(new Date()) - this.timestamp*1000 - this.currencyAll[item.small_name].time*1000 > 20000){
                  var obj3 = {isBs: true}
                }else{
                  var obj3 = {isBs: false}
                }
              }else{
                var obj3 = {isBs: false}
              }
              item = { ...item,...obj,...obj3 };
              return item
            });
            if(this.tabIdx == 0){
              this.list = this.list.filter(item => item.isCollect == true);
              if(this.list.length == 0){
                var zxData = JSON.parse(localStorage.getItem('whList'));
                this.list = zxData.map(item =>{
                  var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                  if(this.isWeekend()){
                    if(Date.parse(new Date()) - this.timestamp*1000 - this.currencyAll[item.small_name].time*1000 > 20000){
                      var obj3 = {isBs: true}
                    }else{
                      var obj3 = {isBs: false}
                    }
                  }else{
                    var obj3 = {isBs: false}
                  }
                  item = { ...item,...obj,...obj3 };
                  return item
                });
              }
            }
          }else if(res.data.code == 20001){
            this.$router.push('/login')
          }
        }).catch(function(err){
            console.log(err)
        })
      },
       jump(cname,currency_type,main_type){
         // this.$router.push('/trading?cname=' + cname)
         localStorage.setItem('mainType',main_type)
         this.$router.push('/ldcoin?cname=' + cname+'&currency_type='+currency_type+'&main_type='+main_type)
       },
       getCurrency(){
          let params = {
            main_type: this.main_type
          }
          if(this.isFirst == 1){
            this.isLoad = false;
            // this.isFirst = 0;
          }else{
            this.isLoad = false;
          }
          var url = JSON.parse(localStorage.getItem('isMn')) ? this.HOSTMn + '/api/index/getCurrency' : '/api/index/getCurrency';
          this.$ajax.post(url,params).then((res) => {
            if(res.data.code == 200){
              let resData = res.data.data;
              if(this.currencyAll){
                let listData = resData.map(item =>{
                  if(this.currencyAll[item.small_name] != undefined){
                    var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                    item = { ...item,...obj };
                    return item
                  }else{
                    var obj = {change_rate: 0,now_price:0,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                    item = { ...item,...obj };
                    return item
                  }
                });
                this.list = listData;//listData.filter(item => item.change_rate != 0)
                // this.list.map(item => {
                //   var newKlineData = this.removeQuotesFromJSON(item.prices);
                //   item.prices = newKlineData;
                //   return item;
                // })
              }else{
                let listData = resData.map(item =>{
                  var obj = {change_rate: 0,now_price:0,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                    item = { ...item,...obj };
                    return item
                });
                this.list = listData;
                // this.list.map(item => {
                //   var newKlineData = this.removeQuotesFromJSON(item.prices);
                //   item.prices = newKlineData;
                //   return item;
                // })
              }
              if(this.tabIdx == 0){
                this.list = this.list.filter(item => item.isCollect == true);
                if(this.list.length == 0){
                  var zxData = JSON.parse(localStorage.getItem('whList'));
                  this.list = zxData.map(item =>{
                    var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
                    item = { ...item,...obj };
                    return item
                  });
                  // this.list.map(item => {
                  //   var newKlineData = this.removeQuotesFromJSON(item.prices);
                  //   item.prices = newKlineData;
                  //   return item;
                  // })
                }
              }
              if(this.list.length > 0){
                  this.isNoData = false;
              }else{
                  this.isNoData = true;
              }
              this.isLoad = false;
            }else if(res.data.code == 20001){
              if(JSON.parse(localStorage.getItem('isMn'))){
                this.$toast.center(this.$t('langNew.mnts'));
              }
              this.$router.push('/login')
            }
          }).catch(function(err){
              console.log(err)
          })
        },
      removeQuotesFromJSON(jsonArr) {//去掉数组引号
        const regex = /"([^"]+)"/g;
        return JSON.parse(JSON.stringify(jsonArr).replace(regex, "$1"));
      },
       search(){
        if(this.key){
          this.list = this.list.filter((item)=>{
            return (item.cname.toUpperCase().indexOf(this.key) > -1 || item.small_name.indexOf(this.key) > -1)
          })
        }else{
          this.getCurrency()
        }
       },
       close(){
           this.$router.push('/index')
       },
       clear(){
           this.key = '';
           this.getCurrency()
       },
       select(idx){
        this.tabIdx = this.main_type = idx;
        this.list = [];
        this.getCurrency();
        // this.websocketonopen();
       },
       collect(name,isCollect){
         if(this.collectArr.length > 0){
          if(isCollect){
             this.collectArr = this.collectArr.filter((item,index) => {
              return item != name;
            });
          }else{
            this.collectArr.forEach(item => {
              if(this.collectArr.indexOf(name) === -1){
                this.collectArr.push(name);
              }
            });
          }
         }else{
           this.collectArr.push(name);
         }
          this.list = this.list.map(item =>({
            ...item,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true
          }));
         localStorage.setItem('collectArr',JSON.stringify(this.collectArr));
         this.getCurrency();
       },
       toFixed4(val,cname){
          var leng;
          var defval = parseFloat(val);
          if(cname){
            if(cname == 'AUDUSD' || cname == 'GBPUSD' || cname == 'EURUSD' || cname == 'NZDUSD' || cname == 'USDCAD' || cname == 'USDCHF' || cname == 'USDCNH' || cname == 'USDHKD' || cname == 'USDSGD' || cname == 'EURAUD' || cname == 'EURCAD' || cname == 'EURGBP' || cname == 'EURNZD' || cname == 'GBPAUD' || cname == 'GBPCAD' || cname == 'GBPCHF' || cname == 'GBPNZD' || cname == 'NZDCAD' || cname == 'NZDCHF' || cname == 'CADCHF' || cname == 'AUDCAD' || cname == 'AUDCHF' || cname == 'XRPUST' || cname == 'XRP'){
              leng = 5
            }else if(cname == 'USDJPY' || cname == 'EURJPY' || cname == 'GBPJPY' || cname == 'NZDJPY' || cname == 'AUDNZD' || cname == 'CADJPY' || cname == 'CHFJPY' || cname == 'AUDJPY' || cname == 'XAGUSD' || cname == 'EOSUST' || cname == 'EOS'){
              leng = 3
            }else if(cname == 'XAUUSD' || cname == 'BTCUST' || cname == 'ETHUST' || cname == 'LTCUST' || cname == 'BCHUST' || cname == 'BTC' || cname == 'ETH' || cname == 'LTC' || cname == 'BCH'){
              leng = 2
            }else if(cname == 'TRX' || cname == 'TRXUST'){
              leng = 6
            }else{
              if(defval){
                if(defval.toString().indexOf(".") > -1){
                  if(!isNaN(defval.toString().split('.')[0]) || defval.toString().split('.')[1] != undefined){
                    leng = defval.toString().split('.')[1].length;
                  }
                }else{
                  leng = 0
                }
              }
            }
          }else{
            if(defval){
              if(defval.toString().indexOf(".") > -1){
                if(!isNaN(defval.toString().split('.')[0]) || defval.toString().split('.')[1] != undefined){
                  leng = defval.toString().split('.')[1].length;
                }
              }else{
                leng = 0
              }
            }
          }
          // defval = parseFloat(defval);
          return leng;
        }
    },
    // watch:{
    //   list:{
    //     handler: function(newValue,oldValue){
    //       var oldTimers2 = localStorage.getItem('oldTimers') || 0;
    //       if(oldValue.length == 0 || newValue.length == 0){
    //         newValue.forEach((item,i) => {
    //           if(parseFloat(newValue[i].change_rate) >= 0){
    //               $('.table-body .tr').eq(i).find('.buy').removeClass('bg');
    //               $('.table-body .tr').eq(i).find('.sell').removeClass('bg');
    //             }else{
    //               $('.table-body .tr').eq(i).find('.buy').addClass('bg');
    //               $('.table-body .tr').eq(i).find('.sell').addClass('bg');
    //             }
    //         })
    //       }else{
    //         var timers = parseFloat(Date.parse(new Date()) - oldTimers2);
    //         localStorage.setItem('oldTimers',Date.parse(new Date()))
    //         newValue.forEach((item,i) => {
    //           if(timers >= 500){
    //             if(newValue[i].isBs) return;
    //             if(String(newValue[i].now_price).indexOf(".") > -1){//小数
    //               var length = this.toFixed4(newValue[i].now_price,newValue[i].cname);
    //               var leng = String(newValue[i].now_price).split('.')[1].length;//实际返回价格小数位
    //               var lastNum = String(newValue[i].now_price).split('.')[1].substring(leng-1);
    //               var curNum = 10;
    //               var jiajian = Math.random() > 0.5 ? '-' : '+';
    //               var jiajian2 = Math.random() > 0.5 ? '+' : '-';
    //               var random1 = jiajian + (parseFloat(1/Math.pow(curNum,length))).toFixed(length);
    //               var random2 = jiajian2 + (parseFloat(1/Math.pow(curNum,length)) * Math.floor(Math.random()*5)).toFixed(length);
    //               var random = (parseFloat(random1)).toFixed(length);
    //             }else{
    //               var length = 0;
    //               var lastNum = String(newValue[i].now_price).substring(String(newValue[i].now_price).length-1);
    //               var curNum = 1;
    //               var jiajian = Math.random() > 0.5 ? '-' : '+';
    //               var random = jiajian + 1;
    //             }
    //             if(random > 0){//parseFloat(newValue[i].now_price) >= parseFloat(oldValue[i].now_price)
    //               $('.table-body .tr').eq(i).find('.buy').removeClass('bg');
    //               $('.table-body .tr').eq(i).find('.sell').removeClass('bg');
    //               $('.table-body .tr').eq(i).find('.buy').text((parseFloat(newValue[i].now_price) + parseFloat(random) + parseFloat(newValue[i].buy_add_money)).toFixed(length));
    //                $('.table-body .tr').eq(i).find('.sell').text((parseFloat(newValue[i].now_price) + parseFloat(random)).toFixed(length));
    //             }else{
    //               $('.table-body .tr').eq(i).find('.buy').addClass('bg');
    //               $('.table-body .tr').eq(i).find('.sell').addClass('bg');
    //               $('.table-body .tr').eq(i).find('.buy').text((parseFloat(newValue[i].now_price) + parseFloat(random) + parseFloat(newValue[i].buy_add_money)).toFixed(length));
    //                $('.table-body .tr').eq(i).find('.sell').text((parseFloat(newValue[i].now_price) + parseFloat(random)).toFixed(length));
    //             }
    //           }else{
    //             if(newValue[i].isBs) return;
    //             if(parseFloat(newValue[i].now_price) >= parseFloat(oldValue[i].now_price)){
    //               $('.table-body .tr').eq(i).find('.buy').removeClass('bg');
    //               $('.table-body .tr').eq(i).find('.sell').removeClass('bg');
    //             }else{
    //               $('.table-body .tr').eq(i).find('.buy').addClass('bg');
    //               $('.table-body .tr').eq(i).find('.sell').addClass('bg');
    //             }
    //           }
    //         })
    //       }
    //     },
    //     deep: true,
    //     immediate: false,
    //   }
    // },
    beforeDestroy(){
      this.closeTimer();
      clearInterval(this.downTimer);
      this.downTimer = null;
    },
    destroyed() {
      this.closeTimer();
      clearInterval(this.downTimer);
      this.downTimer = null;
      // this.websock.close();
    }
}
</script>
<style scoped>
  .tab_menu{ display:block;}
  .tab_menu li{ display:block; font-size:.28rem;
  border-bottom:2px solid rgba(0,0,0,0); float:left; margin-right:.2rem; color:#7d7d7d; cursor:pointer;
  border-radius: .5rem;
  background-color: #ececec;
  color: #828282;
  font-size: .2rem;
  padding: .1rem .3rem;
  }
  .tab_menu li.cur{
    font-size: .2rem;
    color: #000;
    font-weight: bold;
    padding: .1rem .3rem;
  	text-align: center;
  	background-color: #fcd535;
  	border-radius: .3rem;}
  .img-icon{
    width:.4rem; border-radius:100%;height:.4rem;margin-right: .2rem;
  }
  .tab {
    display: flex;
    justify-content: center;
    height: 64px;
    padding: 10px;
    margin: 50px auto;
    width: auto;
  }
  .tab-item {
    width: 2rem;
    line-height: 44px;
    cursor: pointer;
    color: #333;
    position: relative;
    font-size: .24rem;
    color: #000;
    text-align: center;
  }
  /* .tab-item:not(:first-child) {
    margin-left: 22px;
  } */
  .tab-item.active{
    /* width: 1.6rem; */
    /* padding: 0 30px; */
  	height: 44px;line-height: 44px; text-align: center;
  	background-color: #fff;
  	border-radius: .1rem;color:#000;}

    .quotes-head{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      width: 100%;
      background: #fff;
    }
    /* .table-body {
        position: absolute;
        z-index: 9;
        top: 4.6rem;
        bottom: .1rem;
        width: 100%;
        height: auto;
        padding: 0 .46rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
    } */
     .search-wrap{
        display: flex;
        align-items: center;
        padding: .24rem .3rem;
        color: #909090;
        font-size: .24rem;
    }
     .search-wrap .text{
        flex: 1;
        text-align: center;
    }
     .search-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .46rem .46rem .2rem;
        box-sizing: border-box;
    }
     .search-box .search-lt{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      padding: .28rem .24rem;
      border-radius: .1rem;
      background: #f4f4f4;
    }
     .back{
        width: .4rem;
    }
     .icon{
        width: .6rem;
        height: .6rem;
    }
     .search-box .clear-img{
      width: .6rem;
    }
     .search-box .clear{
      padding-left: .32rem;
      color: #2d66cf;
      font-size: .48rem;
    }
    .tab-wrap{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 .45rem;
      background: #fff;
    }
    .tab-wrap .tab-box{
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      overflow-x: scroll;
    }
    .tab-wrap .tab{
      position: relative;
      margin-right: .5rem;
      padding: .42rem 0;
      color: #150700;
      font-size: .46rem;
      word-break: keep-all;
      white-space: nowrap;
      /* border-top: 1px solid #f0f0f0; */
    }
    .tab-wrap .tab.active{
      font-size: .52rem;
    }
    .tab-wrap .tab.active::after{
      position: absolute;
      left: 50%;
      bottom: .1rem;
      content: '';
      width: 0.72rem;
      height: 0.06rem;
      background: #2d66cf;
      border-radius: 0.03rem;
      transform: translateX(-50%);
    }
      .table-head{
        display: flex;
        align-items: center;
        padding: .26rem .4rem;
        background: #fff;
    }
     .table-head .th{
        width: 16.35%;
        color: #646464;
        font-size: .2rem;
    }
     .table-head .th.text-right{
      /* padding-right: .24rem; */
    }
     .table-body{
        padding: 0 .66rem 0 .36rem;
        background: #fff;
    }
     .table-body .tr{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .15rem 0;
    }
     .search{
        flex: 1;
        height: 30px;
        color: #909090;
        font-size: .24rem;
        text-indent: .12rem;
    }
    .cotainer .table-body{
        padding: 0 .76rem 0 .36rem;
        background: #fff;
    }
    .cotainer .table-body .tr{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .15rem 0;
    }
     .table-body .tr .item{
        width: 16.35%;
    }
     .table-body .tr .item.sell{
       padding: .1rem 0;
       /* background: #dc2626; */
       color: #dc2626;
       border-radius: .12rem;
     }
      .table-body .tr .item.buy{
       margin-left: .2rem;
       padding: .1rem 0;
       /* background: #1cac88; */
       color: #1cac88;
       border-radius: .12rem;
     }
     .table-body .tr .item.bg{
      /* color: #f22748; */
      color:#000;
      /* background: #fdedee; */
    }
     .table-body .coin .t1{
       display: flex;
       align-items: center;
        color: #000;
        font-size: .2rem;
    }
     .table-body .coin .t2{
      padding-top: .25rem;
      color: #646464;
      font-size: .26rem;
    }
     .table-body .change{
        color: #00994e;
        font-size: .2rem;
    }
     .table-body .sell{
      color: #000;
      font-size: .2rem;
    }
     .table-body .buy{
      color: #000;
      font-size: .2rem;
    }
     .table-body .tr .collect{
      /* position: absolute;
      right: -.55rem;
      top: 50%; */
      width: .4rem;
      height: .4rem;
      margin-right: 10px;
      /* transform: translateY(-50%); */
    }
    .fill-red >>> path {
      fill:rgba(255,0,0,0.5);
    }
    .fill-green >>> path {
      fill:rgba(0,128,0,0.5);
    }
</style>



// WEBPACK FOOTER //
// src/components/marketHome.vue